import {Box} from '@tempo/core';
import {StarIcon} from '@tempo/icons';

export type ReviewsItem = {
	grade: number;
	text: string;
	pseudo: string;
};
export const LandingReviews: React.FC<{items: ReviewsItem[]}> = ({items}) => {
	return (
		<>
			{items.map((props, i) => (
				<ReviewItem {...props} key={'review-' + i} />
			))}
		</>
	);
};

export const ReviewItem: React.FC<ReviewsItem> = ({grade, text, pseudo}) => {
	return (
		<Box maxW="300px">
			<Box p="6">
				<Box alignItems="baseline">
					<Box display="flex" mt="2" alignItems="center">
						{[...Array(5)].map((_, i) => {
							if (i < grade) {
								return (
									<StarIcon
										size="medium"
										key={'star' + i}
										boxSize={6}
										color="icon.neutral.primary.default"
									/>
								);
							} else {
								return (
									<StarIcon
										size="medium"
										key={'star' + i}
										boxSize={6}
										color="icon.neutral.secondary.default"
									/>
								);
							}
						})}
						<Box as="span" ml="2" fontSize="sm">
							{grade}/5
						</Box>
					</Box>
					<Box mt="4" textAlign="left">
						{text}
					</Box>
					<Box mt="4" textAlign="left" fontWeight="semibold">
						{pseudo}
					</Box>
				</Box>
			</Box>
		</Box>
	);
};
